import React from 'react';
import AlertsPage from '../components/alerts/AlertsPage';
import './Alerts.css';

const Alerts = () => {
  return <AlertsPage />;
};

export default Alerts;
